export default {
    elearnarticle:{},
    elearnarticleData : [],
    authorList : []
}